import { render, staticRenderFns } from "./WDGButton.vue?vue&type=template&id=e6280d88&"
import script from "./WDGButton.vue?vue&type=script&lang=js&"
export * from "./WDGButton.vue?vue&type=script&lang=js&"
import style0 from "./WDGButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../prospect-setup/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports